export const testimonials = [
  {
    id: 1,
    name: 'Paula Shigueoka',
    role: 'Professora do 3º ano',
    instagram: '@paulashigueoka',
    text: 'Depois do curso estou usando muito a Inteligência Artificial. Abriu muito a minha mente. Amei. Estou amando!',
    rating: 5,
    image: 'https://public.readdy.ai/ai/img_res/b7ae87991c6f02c7968cf96dd5010ada.jpg'
  },
  {
    id: 2,
    name: 'Inês Rondi',
    role: 'Contadora de Histórias',
    instagram: '@inesrondicontadoradehistoria',
    text: 'Rosana, obrigada por tornar o complexo mais simples, o desconhecido mais acessível e o aprendizado tão leve e prazeroso. O curso me trouxe novos conhecimentos e um sentimento de gratidão.',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20smiling%20female%20educator%2040s%20warm%20friendly%20expression%20glasses%20professional%20attire%20soft%20natural%20lighting%20clean%20white%20background%20headshot%20photography&width=400&height=400&seq=test002&orientation=squarish'
  },
  {
    id: 3,
    name: 'Luana Dracena',
    role: 'Professora',
    instagram: '@luanadracena',
    text: 'Arrasou Rô! Muitas informações, conteúdo riquíssimo e necessário!',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20smiling%20female%20teacher%2035s%20confident%20friendly%20expression%20professional%20attire%20soft%20natural%20lighting%20clean%20white%20background%20headshot%20photography&width=400&height=400&seq=test003&orientation=squarish'
  },
  {
    id: 4,
    name: 'Mariana Costa',
    role: 'Coordenadora Pedagógica',
    instagram: '@marianacostaeduca',
    text: 'O curso transformou completamente minha forma de planejar aulas e engajar os alunos. A metodologia é clara e os resultados são imediatos.',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20smiling%20female%20coordinator%2045s%20confident%20professional%20expression%20business%20attire%20soft%20natural%20lighting%20clean%20white%20background%20headshot%20photography&width=400&height=400&seq=test004&orientation=squarish'
  },
  {
    id: 5,
    name: 'Roberto Silva',
    role: 'Professor de Matemática',
    instagram: '@professorrobertosilva',
    text: 'Consegui economizar horas de trabalho toda semana. A IA me ajuda a criar atividades personalizadas para cada aluno.',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20smiling%20male%20teacher%2038s%20friendly%20approachable%20expression%20casual%20professional%20attire%20soft%20natural%20lighting%20clean%20white%20background%20headshot%20photography&width=400&height=400&seq=test005&orientation=squarish'
  },
  {
    id: 6,
    name: 'Ana Beatriz Santos',
    role: 'Professora de Língua Portuguesa',
    instagram: '@profanabeatriz',
    text: 'Didática excelente! A Rosana explica com clareza e mostra caminhos práticos que realmente funcionam. Recomendo com segurança!',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20smiling%20female%20teacher%2032s%20enthusiastic%20friendly%20expression%20professional%20attire%20soft%20natural%20lighting%20clean%20white%20background%20headshot%20photography&width=400&height=400&seq=test006&orientation=squarish'
  }
];